import { render, staticRenderFns } from "./tenderProMgmt.vue?vue&type=template&id=5c49fad9&scoped=true"
import script from "./tenderProMgmt.vue?vue&type=script&lang=js"
export * from "./tenderProMgmt.vue?vue&type=script&lang=js"
import style0 from "./tenderProMgmt.vue?vue&type=style&index=0&id=5c49fad9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c49fad9",
  null
  
)

export default component.exports